import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const AddIcon = ({
  title = 'Add',
  viewBox = '0 0 20 20',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    <path d="M10 20C4.5 20 0 15.5 0 10S4.5 0 10 0s10 4.5 10 10-4.5 10-10 10zm0-18.5c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5-3.8-8.5-8.5-8.5zm.8 11.7H9.2v-2.5H6.8V9.2h2.5V6.8h1.5v2.5h2.5v1.5h-2.5v2.4z" />
  </CreateIconComponent>
);

export default AddIcon;
